import React, { Component } from 'react';
import Wizard from './Services/Wizard.js';
import SyncContributor from './Services/SyncContributor';
import { connect } from 'react-redux';
var _ = require('lodash');

const GettingStarted = () => <Wizard />;
export default GettingStarted;
